import { baseColours } from "./colourDefinitions.js";
/**
 * Remove the alpha value from a colour
 *
 * @param colour The colour to remove the alpha value from
 * @returns The colour without the alpha value
 */
export function removeAlpha(colour) {
    return colour.replace(/\s*\/\s*<alpha-value>\s*/, "");
}
/**
 * Get the colour for a theme colour
 *
 * @param colour The colour to get
 * @returns The colour
 */
export function getColourFromTheme(colour) {
    return removeAlpha(baseColours[colour][500]);
}
/**
 * Get the colour variable for a colour
 *
 * @param colour The colour to get the variable for
 * @returns The colour variable
 */
export function getColourVariable(colour) {
    return { "--colour": getColourFromTheme(colour) };
}
//# sourceMappingURL=colourHelpers.js.map